<template>
    <div>
        <qrcode-stream @decode="onDecode"></qrcode-stream>
    </div>
</template>

<script>
    import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'

	export default {
		name: 'EventScan',
        components: {
            QrcodeStream,
            QrcodeDropZone,
            QrcodeCapture
        },
        props: {
            hashid: {
                type: String,
                // Object or array defaults must be returned from
                // a factory function
            },
        },
        methods: {
            onDecode (decodedString) {
                // ...
                //console.log(decodedString)
                if (decodedString.length == 16)
                {
                    axios.patch('/api/guest/'+decodedString+'/attend').then((response) => {
                        if (response.data.guest)
                        {
                            //window.navigator.vibrate(300)
                            var name = response.data.guest.name
                            var company = response.data.guest.company?response.data.guest.company:''
                            Swal.fire({
                                //title: 'Error',
                                html:
                                    '<b>Welcome:</b><br/><br/>' +
                                    ''+name+'<br/>'+
                                    '<span class="text-gray-600">'+company+'</span>',
                                //icon: 'error',
                                confirmButtonText: 'Done',
                            }).then((result) => {
                                if (result.value)
                                {

                                }
                            })
                        }
                    }).catch((error) => {
                        /*Swal.fire({
                            title: 'Error',
                            text: 'Unable to perform request',
                            icon: 'error',
                            confirmButtonText: 'OK'
                        }).then((result) => {
                        })*/
                    })

                }
            }
        },
        mounted() {

        }
	}
</script>

<style scoped>

</style>
